<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{ $t('page.attachment') }}</h4>
        </div>
        <div class="card-body">
          <div class="w-100">
            <DropZone
              @drop.prevent="drop"
              @change="selectedFile"
              :fileInfo="{
                title: this.$t('page.files_upload.click_upload_pictures_videos_documents'),
                accept: this.$t('page.files_upload.type'),
                limit: '50M',
              }"
              :ID="ID"
              :accept="'.ppt,.pptx,.pdf,.xls,.xlsx,.doc,.docx,.png,.jpeg,.jpg,.mp4,.mov,.stp,.glb'"
            />
            <h4
              class="card-title mb-1 mt-3 flex-grow-1"
              v-show="
                showfiles['image'].length ||
                showfiles['video'].length ||
                showfiles['document'].length
              "
            >
              {{this.$t('page.files_upload.uploaded_data')}}
            </h4>
            <div
              class="border border-solid rounded p-3"
              v-show="
                showfiles['image'].length ||
                showfiles['video'].length ||
                showfiles['document'].length
              "
            >
              <div v-show="showfiles['image'].length">
                <div>
                  <div class="border-primary fs-14 material-title">{{this.$t('base.picture')}}</div>
                </div>
                <div class="product-img-slider sticky-side-div ps-5 pe-5">
                  <SwiperTool
                    :swiperInfo="{
                      type: 'image',
                      page: 'assetform',
                      spaceBetween: 10,
                      slidesPerView: 15,
                      actionsClass: [
                        { name: 'ri-eye-fill', action: 'view' },
                        { name: 'ri-download-2-fill', action: 'download' },
                        { name: 'ri-delete-bin-5-fill', action: 'delete' },
                      ],
                    }"
                    :list="showfiles['image']"
                    @deleteFile="deleteFile"
                  >
                  </SwiperTool>
                </div>
              </div>
              <div class="mt-4 mb-4" v-show="showfiles['video'].length">
                <div>
                  <div class="border-primary fs-14 material-title">{{this.$t('base.video')}}</div>
                </div>
                <div class="product-img-slider sticky-side-div ps-5 pe-5">
                  <SwiperTool
                    :swiperInfo="{
                      type: 'video',
                      page: 'assetform',
                      spaceBetween: 10,
                      slidesPerView: 15,
                      actionsClass: [
                        { name: 'ri-play-circle-line', action: 'play' },
                        { name: 'ri-download-2-fill', action: 'download' },
                        { name: 'ri-delete-bin-5-fill', action: 'delete' },
                      ],
                    }"
                    :list="showfiles['video']"
                    @deleteFile="deleteFile"
                  >
                  </SwiperTool>
                </div>
              </div>
              <div v-show="showfiles['document'].length">
                <div>
                  <div class="border-primary fs-14 material-title">{{this.$t('base.document')}}</div>
                </div>
                <div class="product-img-slider sticky-side-div ps-5 pe-5">
                  <SwiperTool
                    :swiperInfo="{
                      type: 'document',
                      page: 'assetform',
                      spaceBetween: 10,
                      slidesPerView: 15,
                      actionsClass: [
                        { name: 'ri-eye-fill', action: 'view' },
                        { name: 'ri-download-2-fill', action: 'download' },
                        { name: 'ri-delete-bin-5-fill', action: 'delete' },
                      ],
                    }"
                    :list="showfiles['document']"
                    @deleteFile="deleteFile"
                  >
                  </SwiperTool>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DropZone from "@/components/widgets/dropZone.vue";
import SwiperTool from "@/components/swiperTool.vue";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import {getUploadFileSign, getUploadFileDetail,postUpdateFile} from "@/service";
import {imageCompress} from '@/utils/common.js'
import _ from "lodash";


export default {
  emits: ["filesChange", "openAlert"],
  props: {
    ID:{
      type:String,
      default:()=>{
        return ''
      }
    },
    faultEditableTabsValue:{
      type:String,
      default:()=>{
        return ''
      }
    },
    files: {
      type: Object,
      default: () => {
        return { image: [], video: [], document: [] };
      },
    },
    filesNums:{
      type: Array,
      default: () => {
        return [];
      },
    }
  },
  setup() {},
  data() {
    return {
      showfiles: { image: [], video: [], document: [] },
      fileMaxSize: 1024 * 1024 * 50,
      filesNum:[],
      files_backups:{image: [], video: [], document: []},
    };
  },
  components: {
    DropZone,
    SwiperTool,
  },
  watch: {
    showfiles: {
      handler(newVal) {      
        let reslut = []
          for(let key in this.files_backups){
            reslut.push(...this.files_backups[key])
          }
          console.log("showfiles",reslut);
        this.$emit("filesChange", {files:newVal,id:this.faultEditableTabsValue,filesNums:reslut});
      },
      deep: true,
      immediate: true,
    },
    files: {
      handler(newVal) {
        this.showfiles = newVal;
      },
      deep: true,
    },
    filesNums: {
      handler(newVal) {
        this.filesNum = newVal;
      },
      deep: true,
    },

  },
  mounted() {
  },
  methods: {
    checkFile(file) {
      let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
      let suffix = name.substring(name.lastIndexOf("."));
      let type = /\.(png|jpeg|jpg)$/.test(suffix)
        ? "image"
        : /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
        ? "document"
        : "video";
      let i = this.showfiles[type].findIndex((item) => {
        let object_name = /^device\//.test(item.object_name)
          ? item.object_name.substring(44)
          : item.object_name;
        return object_name === name;
      });
      return i == -1;
    },
    async selectedFile() {
      let dropzoneFile = document.getElementById(this.ID).files[0];
      if (!dropzoneFile) return;
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
          "openAlert",
          {
            variant: "danger",
            content: this.$t('page.files_upload.file_size_cannot_exceed_50M'),
            icon: "ri-error-warning-line",
          },
          false
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }
      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "openAlert",
          {
            variant: "danger",
            content: this.$t('page.files_upload.same_name_file'),
            icon: "ri-error-warning-line",
          },
          false
        );
        document.getElementById(this.ID).value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(dropzoneFile.name.lastIndexOf("."));
      if(/\.(png|jpeg|jpg)$/.test(suffix)){
        let file = await imageCompress(dropzoneFile)
        this.uploadFileSign(file);
      }else{
        this.uploadFileSign(dropzoneFile);
      }
    },
    async drop(e) {
      let dropzoneFile = e.dataTransfer.files[0];
      if (!dropzoneFile) return;
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
          "openAlert",
          {
            variant: "danger",
            content: this.$t('page.files_upload.file_size_cannot_exceed_50M'),
            icon: "ri-error-warning-line",
          },
          false
        );
        document.getElementById(this.ID).value = "";
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "openAlert",
          {
            variant: "danger",
            content: this.$t('page.files_upload.same_name_file'),
            icon: "ri-error-warning-line",
          },
          false
        );
        document.getElementById(this.ID).value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(dropzoneFile.name.lastIndexOf("."));
      if(/\.(png|jpeg|jpg)$/.test(suffix)){
        let file = await imageCompress(dropzoneFile)
        this.uploadFileSign(file);
      }else{
        this.uploadFileSign(dropzoneFile);
      }
    },
    deleteFile(i, type) {
      Swal.fire(this.$t('base.delete_success'));
      this.showfiles[type].splice(i, 1);
      this.files_backups[type].splice(i,1);
    },
    uploadFileSign(file) {
      Swal.fire({ title: this.$t('page.files_upload.uploading'), showConfirmButton: false });
      Swal.showLoading();
      let filename = file.name;
      let objectName = `device/${uuidv4()}/${filename}`
      let params = {
        object: objectName,
        method:'upload'
      };
      getUploadFileSign(params)
        .then((res) => {
          if (res && res.payload) {
            axios
              .put(
                res.payload.signedUrl,
                file,
                {headers:{"Content-Type":file.type}}
              )
              .then(() => {
                let params = {
                  object: objectName,
                };
                getUploadFileDetail(params).then((resDetail) => {
                  if (resDetail && resDetail.payload) {
                    let detail = resDetail.payload
                    let info = {
                      url: detail.url,
                      etag: detail.etag,
                      size: detail.size,
                      content_type: detail.contentType,
                      object_name: detail.objectName,
                      last_modified: detail.lastModified,
                    };
                    document.getElementById(this.ID).value = "";
                    postUpdateFile(info).then((post) => {
                      if (post && post.payload) {
                        let file = _.cloneDeep(post.payload);
                        let suffix = info.object_name.substring(
                          info.object_name.lastIndexOf(".")
                        );
                        let type_tag = ''
                        if (/\.(png|jpeg|jpg)$/.test(suffix)) {
                          this.showfiles["image"].push(info);
                          type_tag = 'image'
                        } else if (
                          /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
                        ) {
                          this.showfiles["document"].push(info);
                          type_tag = 'document'
                        } else {
                          this.showfiles["video"].push(info);
                          type_tag = 'video'
                        }
                        this.filesNum.push(file.id);
                        this.files_backups[type_tag].push(file.id)
                        setTimeout(() => {
                          this.formValidataAlert = false;
                        }, 3000);
                      }
                    });
                    Swal.close();
                    this.$emit(
                      "openAlert",
                      {
                        variant: "success",
                        content: this.$t('base.upload_success'),
                        icon: "ri-check-double-line",
                      },
                      false
                    );
                  }
                });
              })
              .catch(() => {
                Swal.close();
                this.$emit(
                  "openAlert",
                  {
                    variant: "danger",
                    content: this.$t('base.delete_failed_please_try_again'),
                    icon: "ri-error-warning-line",
                  },
                  false
                );
                document.getElementById(this.ID).value = "";
              });
          }
        })
        .catch(() => {
          Swal.close();
          this.$emit(
            "openAlert",
            {
              variant: "danger",
              content: this.$t('base.delete_failed_please_try_again'),
              icon: "ri-error-warning-line",
            },
            false
          );
          document.getElementById(this.ID).value = "";
        });
    },
  },
  beforeUnmount(){
    this.files_backups = {image: [], video: [], document: []}
  },
};
</script>
<style lang="scss" scoped>
.material-title {
  border-left: 3px solid;
  padding-left: 8px;
  height: 22px;
  line-height: 22px;
}
</style>
